var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddToFavoritesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_add_to_favorites_active",
    transform: "translate(-280 -145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(92 -216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-2",
    "data-name": "icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 32,
    height: 32,
    transform: "translate(188 361)",
    fill: "rgba(0,0,0,0.5)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(-24.5 6.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M223.775,376.3l.97-4.364-.727-.727-2.805-2.632v-.416l4.883-.935.762-1.42,1.8-2.632s1.247.935,1.385,1.455a13.026,13.026,0,0,0,.762,1.974,1.847,1.847,0,0,0,1.039.831c.346.069.935.554,1.177.589a10.4,10.4,0,0,1,1.385.139c.312.1.762.1.9.173s.693.8.589,1.074-1.385.97-1.489,1.108-1.074.8-1.143,1.177-.138,3.325-.242,3.706a5.313,5.313,0,0,0,0,1.316l-.208.52-3.948-1.835s-1.42.069-1.455.242-.831.208-1,.381-1.5,1.026-1.5,1.026l-.892.186Z",
    fill: "#f1cf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star",
    d: "M13.708,17.343a1.288,1.288,0,0,1-.6-.15L9.65,15.378a.185.185,0,0,0-.174,0L6.023,17.193a1.3,1.3,0,0,1-1.88-1.366L4.8,11.982a.187.187,0,0,0-.055-.166L1.955,9.091a1.3,1.3,0,0,1,.72-2.21l3.859-.56a.187.187,0,0,0,.141-.1L8.4,2.718a1.3,1.3,0,0,1,2.324,0l1.726,3.5a.188.188,0,0,0,.141.1l3.862.561a1.3,1.3,0,0,1,.72,2.21l-2.795,2.723a.188.188,0,0,0-.055.166l.659,3.845a1.3,1.3,0,0,1-1.275,1.516Zm-4.144-3.1a1.289,1.289,0,0,1,.6.15l3.453,1.815a.178.178,0,0,0,.2-.014.18.18,0,0,0,.075-.183l-.66-3.846a1.3,1.3,0,0,1,.372-1.147L16.4,8.3a.187.187,0,0,0-.1-.319l-3.861-.561a1.294,1.294,0,0,1-.975-.709L9.73,3.211a.187.187,0,0,0-.336,0l-1.725,3.5a1.294,1.294,0,0,1-.976.709L2.832,7.98a.187.187,0,0,0-.1.319l2.794,2.724a1.3,1.3,0,0,1,.372,1.147l-.66,3.846a.187.187,0,0,0,.273.2L8.961,14.4a1.294,1.294,0,0,1,.6-.149Z",
    transform: "translate(218.937 360.504)",
    fill: "#f1cf00"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddToFavoritesActive);
export default __webpack_public_path__ + "static/media/icon_add_to_favorites_active.bbe4323459beae9d85f11a188cf2eaf1.svg";
export { ForwardRef as ReactComponent };